import { Circle, BoxProps } from '@chakra-ui/react';
import { useStyleConfig } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

export const colorPropTypes = ['black', 'grey', 'silver', 'blue', 'green', 'red', 'gold'];
export const sizePropTypes = ['md', 'lg'];

const propTypes = {
  color: PropTypes.oneOf(colorPropTypes),
  size: PropTypes.oneOf(sizePropTypes)
};

const defaultProps = {
  color: 'blue',
  size: 'md'
};

export type IndicatorProps = BoxProps & {
  color?: string;
  size?: string;
};
export default function Indicator(props: IndicatorProps): React.ReactElement {
  const { __css, color, size, ...rest } = props;

  const indicatorStyles = useStyleConfig('Indicator', props);

  return <Circle __css={mergeWith(indicatorStyles, __css)} {...rest} />;
}

Indicator.propTypes = propTypes;
Indicator.defaultProps = defaultProps;
